import { jsx as _jsx } from "react/jsx-runtime";
const SvgFootball = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 1.52002C3.52818 1.52002 1.52 3.52819 1.52 6.00002C1.52 8.47185 3.52818 10.48 6 10.48C8.47183 10.48 10.48 8.47185 10.48 6.00002C10.48 3.52819 8.47183 1.52002 6 1.52002ZM4.84182 2.09275L6 3.25093L7.15819 2.09275C8.04988 2.35618 8.81292 2.91869 9.33455 3.66138L8.74909 5.08366L10.0727 5.99366C10.0727 5.99579 10.0727 5.99789 10.0727 6.00002C10.0727 6.96335 9.73956 7.84868 9.18182 8.54547H8.03637L7.64182 9.72911C7.13979 9.95008 6.58435 10.0727 6 10.0727C5.41566 10.0727 4.86022 9.95008 4.35819 9.72911L3.96364 8.54547H2.81819C2.26045 7.84868 1.92728 6.96335 1.92728 6.00002C1.92728 5.99789 1.92727 5.99579 1.92728 5.99366L3.25091 5.08366L2.66546 3.66138C3.18709 2.91869 3.95012 2.35618 4.84182 2.09275ZM6 4.47275L4.37091 5.59275L4.98182 7.52729H7.01819L7.6291 5.59275L6 4.47275Z",
		fill: "currentColor"
	})
});
export default SvgFootball;
